<style>

.wrapper {
  display: -webkit-flexbox;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  vertical-align: middle;
  width: 100%;
  top: 0;
  left: 0;
  text-align: center;
}
.spanned {
  width: 100px;
  height: 100px;
  vertical-align: middle;
  border-radius: 1px;
  text-align: center;
  margin: 0 auto;
  float: none;
}
/* .cf:before,
.cf:after {
  content: "";
} */
display table:after {
  clear: both;
}
.coffee_cup {
  width: 20px;
  height: 24px;
  border: 1px #000 solid;
  border-radius: 0px 0px 5px 5px;
  position: relative;
  margin: 36px auto;
}
.coffee_cup:after,
.coffee_cup:before {
  position: absolute;
  content: "";
}
.coffee_cup:after {
  width: 5px;
  height: 12px;
  border: 1px #000 solid;
  border-left: none;
  border-radius: 0px 20px 20px 0px;
  left: 20px;
}
.coffee_cup:before {
  width: 1px;
  height: 6px;
  background-color: #000;
  top: -10px;
  left: 4px;
  box-shadow: 5px 0px 0px 0px #000, 5px -5px 0px 0px #000, 10px 0px 0px 0px #000;
  -webkit-animation: steam 1s linear infinite alternate;
  -moz-animation: steam 1s linear infinite alternate;
  animation: steam 1s linear infinite alternate;
}
@-webkit-keyframes steam {
  0% {
    height: 0px;
  }
  100% {
    height: 6px;
  }
}
@-moz-keyframes steam {
  0% {
    height: 0px;
  }
  100% {
    height: 6px;
  }
}
@-moz-keyframes steam {
  0% {
    height: 0px;
  }
  100% {
    height: 6px;
  }
}
@-webkit-keyframes steam {
  0% {
    height: 0px;
  }
  100% {
    height: 6px;
  }
}
@-o-keyframes steam {
  0% {
    height: 0px;
  }
  100% {
    height: 6px;
  }
}
@keyframes steam {
  0% {
    height: 0px;
  }
  100% {
    height: 6px;
  }
}

</style>

<div class="wrapper my-2">
	<div class="spanned">
		<div class="coffee_cup"></div>
	</div>
</div>